import api from "./api";
import {mapEmployeeProfileDto} from "../dto/EmployeeProfileDto";

export const createEmployeeProfileForUser = async (userId, dto) => {
    try {
        const res = await api.post(`/EmployeeProfile/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error creating EmployeeProfile:", err);
        throw err;
    }
};

export const updateEmployeeProfileForUser = async (userId, dto) => {
    try {
        const res = await api.patch(`/EmployeeProfile/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error updating EmployeeProfile:", err);
        throw err;
    }
};

export const deleteEmployeeProfileForUser = async (userId) => {
    try {
        const res = await api.delete(`/EmployeeProfile/${userId}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting EmployeeProfile:", err);
        throw err;
    }
};

export const getEmployeeProfileForUser = async (userId) => {
    try {
        const res = await api.get(`/EmployeeProfile/${userId}`);

        return mapEmployeeProfileDto(res.data);
    } catch (err) {
        console.error("Error getting employee profile for user:", err);
        throw err;
    }
};